import script from "./LeaderProjectIndexes.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectIndexes.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectIndexes.vue?vue&type=style&index=0&id=e99d63d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e99d63d0"]])

export default __exports__